import React, { useState } from "react";
import momentLib from "moment";
import { cn } from "../../lib/cn";

function toLocalBoundary(boundary, endOfPeriod) {
  if (boundary == null) return undefined;
  const m = momentLib(boundary);
  if (!m.isValid()) return undefined;
  const adjusted = endOfPeriod ? m.endOf("minute") : m.startOf("minute");
  return adjusted.format("YYYY-MM-DDTHH:mm");
}

export function DatePickerAnt({
  value,
  onChange,
  className,
  showTime,
  disabled,
  style,
  minimumDateTime,
  maximumDateTime,
}) {
  const type = showTime ? "datetime-local" : "date";

  let str = "";
  if (value != null && value !== "") {
    const m = momentLib(value);
    if (m.isValid()) {
      str = showTime ? m.format("YYYY-MM-DDTHH:mm") : m.format("YYYY-MM-DD");
    }
  }

  const minAttr = minimumDateTime != null ? toLocalBoundary(minimumDateTime, false) : undefined;
  const maxAttr = maximumDateTime != null ? toLocalBoundary(maximumDateTime, true) : undefined;

  return (
    <input
      type={type}
      disabled={disabled}
      style={style}
      min={minAttr}
      max={maxAttr}
      value={str}
      onChange={(e) => {
        const v = e.target.value;
        if (!v) {
          onChange?.(null);
          return;
        }
        const m = showTime ? momentLib(v) : momentLib(v, "YYYY-MM-DD", true);
        onChange?.(m.isValid() ? m : null);
      }}
      className={cn(
        "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/20",
        className
      )}
    />
  );
}

export function RangePickerAnt({
  format,
  value,
  onChange,
  className,
  disabled,
}) {
  const fmt = (x) =>
    x == null || x === ""
      ? ""
      : momentLib(x).isValid()
        ? momentLib(x).format("YYYY-MM-DD")
        : "";
  const [start, setStart] = useState(fmt(value?.[0]));
  const [end, setEnd] = useState(fmt(value?.[1]));

  React.useEffect(() => {
    setStart(fmt(value?.[0]));
    setEnd(fmt(value?.[1]));
  }, [value]);

  function emit(s, e) {
    const a = s ? momentLib(s) : null;
    const b = e ? momentLib(e) : null;
    onChange?.(
      [a && a.isValid() ? a : null, b && b.isValid() ? b : null],
      null
    );
  }

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      <input
        type="date"
        disabled={disabled}
        value={start}
        onChange={(e) => {
          const s = e.target.value;
          setStart(s);
          emit(s, end);
        }}
        className="rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-brand"
      />
      <span className="text-slate-400">→</span>
      <input
        type="date"
        disabled={disabled}
        value={end}
        onChange={(e) => {
          const en = e.target.value;
          setEnd(en);
          emit(start, en);
        }}
        className="rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-brand"
      />
    </div>
  );
}

DatePickerAnt.RangePicker = RangePickerAnt;
